import Call from 'containers/Call';
import Administration from 'containers/Administration';
import Profile from 'containers/Profile';
import Answering from 'containers/Answering';
import Favourite from 'containers/Favourite';

export default [
  {
    name: 'answering',
    component: Answering,
    path: '/answering',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/in',
  },
  {
    name: 'calls',
    component: Call,
    path: '/calls',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/in',
  },
  {
    name: 'favourites',
    component: Favourite,
    path: '/favourites',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/in',
  },
  {
    name: 'administrator',
    component: Administration,
    path: '/administration',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    layout: '/in',
  },
  {
    name: 'profile',
    component: Profile,
    path: '/profile',
    icon: 'fas fa-tachometer-alt',
    sidebar: true,
    notShowTopbar: true,
    layout: '/in',
  },
];
